import { observable, action } from 'mobx';
import { notify } from 'react-notify-toast';
import moment from 'moment';

import {getCustomer, getCustomers} from '../../services/customers';
import { getProduct, getProducts } from '../../services/products';
import SaleService from '../../services/sales.js'
import {saleTemplate} from './SaleConstant';


class SaleStore {

    @observable sale = saleTemplate
    @observable customers = []
    @observable isLoading = false
    @observable products = []
    @observable sale_status = "Em análise"

    @action
    handleCustomerChange = async (event, data) => {
        event.preventDefault()
        if (data.value !== null){
            this.customerError=null
            this.loadCustomerToSale(parseInt(data.value))
        }
    }

    @action
    handleCustomerSearchChange = async (event, data_) => {
        event.preventDefault()

        if (this.isLoading)
            return

        this.isLoading = true
        const searchQuery =  data_.searchQuery
        let data = []

        this.showDisableCustomerErrorValidate()
        const isValidName = isNaN(searchQuery) && searchQuery.length > 0
        // const isValidNumber= !isValidName && searchQuery.length > 0

        if (isValidName){
            if(searchQuery.length > 2){
                data = await getCustomers({name:searchQuery})
                if (data.length > 0)
                    this.customers = data.map( d => ({key:d.id, text: `${d.id} - ${d.user.first_name} - ${d.user.last_name}`, value: d.id}))
            }
        } 
        // if (isValidNumber) {
        //     this.sale.customer.id = parseInt(searchQuery)
        //     await this.loadCustomerToSale()
        //     this.customers= [{
        //         id: this.sale.customer.id,
        //         text: `${this.sale.customer.id} - ${this.sale.customer.user.first_name} ${this.sale.customer.user.first_name}`,
        //         value: this.sale.customer.id
        //     }]
        // }
        this.isLoading = false
    }


    @action
    handleDatePicker = async date => { this.sale.date = date }

    
    @action
    handleProductChange = async (event, data) => {
        event.preventDefault()
        if (data.value !== null){
            await this.loadProductToSale(parseInt(data.value))
        }
        this.recalculateAmout()
    }
    
    @action
    handleProductSearchChange = async (event, data_) => {
        event.preventDefault()
        if (this.isLoading)
            return
        this.isLoading = true
        const searchQuery =  data_.searchQuery
        if(searchQuery.length > 2){
            const data = await getProducts({name:searchQuery})
                if (data.length > 0)
                    this.products = data.map( d => ({key:d.id, text: `${d.name}`, value: d.id}))
        }
        this.isLoading = false
    }

    @action
    handleSaleForm = async (event) => {
        event.preventDefault();
        let payload = {"status": 1}

        if(!this.isCustomerValid())
            return
        payload.customer = this.sale.customer.id

        const date = moment(this.sale.date).format('YYYY-MM-DD')
        if(!this.isSaleDateValid(date))
            return
        payload.date = date

        if(!this.areProductsValid())
            return
        if(!this.isSaleQuantityValid())
            return
        payload.products = [
            {
                product: this.sale.products[0].id,
                price: parseFloat(this.sale.products[0].price),
                quantity: parseInt(this.sale.products[0].quantity)
            }
        ]

        payload.amount = this.sale.products[0].price * this.sale.products[0].quantity

        try {
            const isCreatedSale = await this.service.createSale(payload)
            if(isCreatedSale){
                notify.show('Venda registrada com sucesso', 'success')
                this.cleanScreen()
            }
        } catch (error) {
            notify.show('Houve uma falha ao registrar a Venda , tente novamente', 'error')
            console.error(error)
        }
    }

    loadCustomerToSale = async (id) => {
        this.isLoading = true
        const customer = await getCustomer(id)
        if (customer.error){
            notify.show(customer.error.user+"=="+customer.error.tech, 'error')
        }else {
            this.sale.customer = {
                ...customer
            }
        }
        this.isLoading = false
    }

    loadProductToSale = async (id) => {
        this.isLoading = true
        const product = await getProduct(id)
        if (product.error){
            notify.show(product.error.user+"=="+product.error.tech, 'error')
        }else {
            const quantity = this.sale.products[0].quantity
            product.quantity = quantity
            this.sale.products[0] = {
                ...product
            }
        }
        this.isLoading = false
    }

    @action
    onChageSaleQuantity = (event, data)=>{
        event.preventDefault()
        const quantity = data.value
        if (!isNaN(quantity) && parseInt(quantity)>0){
            this.sale.products[0].quantity = parseInt(quantity)
            this.recalculateAmout()
        }
        
    }

    recalculateAmout = ()=>{
        const product = this.sale.products[0]
        if(product.price !== undefined){
            try {
                this.sale.amount = this.sale.products[0].quantity * this.sale.products[0].price
            } catch (error) {
                console.err(error)
            }
        }
    }

    isCustomerValid = () => {
        if(this.sale.customer.id === null){
            notify.show('Para venda o campo cliente é obrigatório', 'error')
            return false
        }
        return true
    }

    showDisableCustomerErrorValidate = () => { this.customerError = null }

    isSaleDateValid = (date) =>{
        const today = moment(new Date()).format('YYYY-MM-DD')
        if (!moment(date).isSameOrAfter(today,'day')){
            notify.show('A data não pode ser menor que a data corrente', 'error')
            return false
        }
        return true
    }


    areProductsValid = () => {
        const products = this.sale.products
        const limit_to_by = 1
        if (products[0].id === undefined || products[0].quantity === undefined || products[0].price === undefined ){
            notify.show("Escolha um produto", "error")
            return false
        }
        if(products.length !== limit_to_by){
            notify.show("erro ao processar o produto, verifique se algum foi selecionado", "error")
            return false
        }
        return true
    }


    isSaleQuantityValid = () => {
        if (this.sale.quantity <1){
            notify.show("A quantidade deve ser de um ou mais", "error")
            return false
        }
        return true
    }

    cleanScreen = () => {
        this.sale = saleTemplate
        this.customers = []
        this.isLoading = false
        this.products = []
    }

    constructor(){
        this.service = SaleService;
    }
}

export default new SaleStore()